import { AccountInfo } from "#app/_ui/components/accounts/AccountInfo";
import { formatMoney } from "#app/lib/currency";
import { Card, CardContent, CardHeader } from "#ui/card";
import { H3 } from "#ui/typography";

import {
  CheckCardList,
  CheckCardListExpandable,
  CheckCardListItem,
} from "./check-card-list";
import type { CheckVm } from "./checks-page.utils";

interface CheckCardAccountsProps extends Omit<
  React.ComponentPropsWithoutRef<"div">,
  "children"
> {
  data: CheckVm;
}

export function CheckCardAccounts({ data, ...props }: CheckCardAccountsProps) {
  return (
    <Card {...props} variant="white-border">
      <CardHeader palette="white" className="mx-20px px-0 pb-15px pt-17px">
        <H3 size="sm" className="font-semibold leading-none">
          Account(s)
        </H3>
      </CardHeader>
      <CardContent className="px-20px pb-5px pt-0">
        {data.split ? (
          <CheckCardListExpandable
            items={data.accounts}
            renderItem={(accountNumber, idx) => (
              <CheckCardListItem
                slot0={<AccountInfo accountNumber={accountNumber} />}
                slot1={formatMoney(data.amounts[idx])}
                key={accountNumber}
              />
            )}
          />
        ) : (
          <CheckCardList>
            <CheckCardListItem
              slot0={<AccountInfo accountNumber={data.account} />}
              slot1={formatMoney(data.amount)}
            />
          </CheckCardList>
        )}
      </CardContent>
    </Card>
  );
}
